import React from "react";

function Event() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5789 11.9982V17.8493C19.5789 20.0044 17.8832 21.75 15.7895 21.75H8.21053C6.11684 21.75 4.42105 20.0044 4.42105 17.8493V11.9982C4.42105 11.4619 4.84737 11.0231 5.36842 11.0231H7.23474C7.75579 11.0231 8.18211 11.4619 8.18211 11.9982V15.0603C8.18309 15.5781 8.38273 16.0746 8.73758 16.4417C9.09243 16.8088 9.57377 17.0168 10.0768 17.0204C10.4368 17.0204 10.7968 16.9131 11.1095 16.6986L12.0095 16.094L12.8432 16.6693C13.4211 17.0692 14.16 17.1179 14.7758 16.7766C15.4011 16.4353 15.7895 15.7819 15.7895 15.0505V11.9982C15.7895 11.4619 16.2158 11.0231 16.7368 11.0231H18.6316C19.1526 11.0231 19.5789 11.4619 19.5789 11.9982ZM21 7.12235V8.09753C21 9.17022 20.4979 10.0479 19.1053 10.0479H4.89474C3.44526 10.0479 3 9.17022 3 8.09753V7.12235C3 6.04965 3.44526 5.172 4.89474 5.172H19.1053C20.4979 5.172 21 6.04965 21 7.12235Z"
        fill="#E1BC41"
      />
      <path
        d="M11.658 5.17297H6.42853C6.27275 4.99906 6.18865 4.76969 6.19396 4.5332C6.19926 4.29671 6.29355 4.07157 6.45695 3.90524L7.80221 2.52049C7.97247 2.34719 8.20225 2.25 8.44168 2.25C8.68112 2.25 8.9109 2.34719 9.08116 2.52049L11.658 5.17297ZM17.5629 5.17297H12.3335L14.9103 2.52049C15.0806 2.34719 15.3104 2.25 15.5498 2.25C15.7892 2.25 16.019 2.34719 16.1893 2.52049L17.5345 3.90524C17.8756 4.25631 17.8851 4.81216 17.5629 5.17297ZM13.8673 11.0231C14.3883 11.0231 14.8146 11.4619 14.8146 11.9982V15.0505C14.8146 15.8307 13.9715 16.2988 13.3462 15.8599L12.4936 15.2748C12.3389 15.17 12.1577 15.1141 11.9725 15.1141C11.7873 15.1141 11.6062 15.17 11.4515 15.2748L10.5609 15.8794C9.93568 16.3085 9.102 15.8404 9.102 15.07V11.9982C9.102 11.4619 9.52832 11.0231 10.0494 11.0231H13.8673Z"
        fill="#E1BC41"
      />
    </svg>
  );
}

export default Event;
